export const IMG = {
  crew: "/images/crew.png",
  kitchen: "/images/kitchen-clean.webp",
  garage: "/images/garage.webp",
  tv: "/images/tv-install.webp",
};

export const PHONE = "772-667-3007";
export const PHONE_HREF = "tel:7726673007";
